import { Callout } from '@studio/design-system/callout';
import { twMerge } from 'cn';
import { Panel as SettingsPanel } from '#~/account/components/settings/types.js';
import { useSettings } from '#~/account/components/hooks.js';

/** LimitExceeded. */
export const LimitExceeded = ({
  className,
  onClick
}: {
  className?: string;
  onClick: () => void;
}) => {
  const settings = useSettings();

  return (
    <Callout
      onClick={() => {
        onClick();
        setTimeout(() => settings(SettingsPanel.Billing), 500);
      }}
      className={className}
      severity='info'
      title={
        <div className='text-left text-sm'>
          Collaborator limit reached.
          <span className='px-4 font-medium text-primary'>Upgrade your plan</span> to invite more
          users.
        </div>
      }
    />
  );
};

/** RoundedProfile. */
export const RoundedProfile = ({
  children,
  className
}: {
  children?: React.ReactNode;
  className?: string;
}) => (
  <div
    className={twMerge(
      'flex h-28 w-28 items-center justify-center rounded-full bg-primary text-white',
      className
    )}
  >
    {children}
  </div>
);
